import { render, staticRenderFns } from "./orderPayWxCode.vue?vue&type=template&id=71cf994a&scoped=true"
import script from "./orderPayWxCode.vue?vue&type=script&lang=js"
export * from "./orderPayWxCode.vue?vue&type=script&lang=js"
import style0 from "./orderPayWxCode.vue?vue&type=style&index=0&id=71cf994a&prod&scoped=true&lang=less"
import style1 from "@/assets/h5css/modals/orderPayWxCode.less?vue&type=style&index=1&id=71cf994a&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cf994a",
  null
  
)

export default component.exports